import { postMobileAccessTokenUnauthorized } from './post-message'
import { eventOriginIsCapacitor } from './verify-capacitor-event-origin'

const NEW_ACCESS_TOKEN_MESSAGE_KEY = 'NEW_ACCESS_TOKEN_MESSAGE_KEY'
const CAPACITOR_TOKEN_REFRESH_FAIL_KEY = 'CAPACITOR_TOKEN_REFRESH_FAIL_KEY'
let getNewTokenFromCapacitorPromise: Promise<string> | null = null

export function getNewTokenFromCapacitor(): Promise<string> {
    if (getNewTokenFromCapacitorPromise === null) {
        getNewTokenFromCapacitorPromise = new Promise((resolve, reject) => {
            // 8 second fail-safe in case something goes wrong in Capacitor
            const timeoutId = setTimeout(() => {
                window.removeEventListener('message', listener)
                getNewTokenFromCapacitorPromise = null
                reject(new Error('Token refresh timed out'))
            }, 8000)

            // One-time listener
            const listener = (event: MessageEvent) => {
                if (eventOriginIsCapacitor(event) === false) {
                    return
                }

                if (event.data?.key === NEW_ACCESS_TOKEN_MESSAGE_KEY) {
                    clearTimeout(timeoutId)
                    window.removeEventListener('message', listener)
                    getNewTokenFromCapacitorPromise = null
                    resolve(event.data.token) // Resolve the promise with the new token
                }

                if (event.data?.key === CAPACITOR_TOKEN_REFRESH_FAIL_KEY) {
                    clearTimeout(timeoutId)
                    window.removeEventListener('message', listener)
                    getNewTokenFromCapacitorPromise = null
                    reject(new Error('Error fetching from capacitor'))
                }
            }

            // Attach the listener and post message to Capacitor
            window.addEventListener('message', listener)
            postMobileAccessTokenUnauthorized()
        })
    }

    return getNewTokenFromCapacitorPromise
}
